/* VTG Bags — show prices in the visitor's home currency.
   Shopify only auto-detects country on Plus plans, so on a visitor's first visit this asks Shopify
   which enabled market fits their location (browsing_context_suggestions.json) and switches the
   storefront to it once. A country picked by hand in the theme's selector is remembered and wins
   from then on. Nothing runs inside the theme editor. */
(function () {
  'use strict';
  if (!window.Shopify || !Shopify.country || Shopify.designMode) return;

  var KEY = 'vtg_country';        // last country we set or the visitor chose
  var TRY = 'vtg_country_try';    // one switch attempt per browser session, so a failure can't loop
  var root = (Shopify.routes && Shopify.routes.root) || '/';

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function tried() { try { return !!sessionStorage.getItem(TRY); } catch (e) { return true; } }
  function markTried() { try { sessionStorage.setItem(TRY, '1'); } catch (e) {} }

  function switchTo(code) {
    if (tried()) return;
    markTried();
    // Same fields as Shopify's own {% form 'localization' %}; form-encoded is what the endpoint accepts.
    var body = new URLSearchParams();
    body.append('form_type', 'localization');
    body.append('utf8', '✓');
    body.append('_method', 'put');
    body.append('country_code', code);
    body.append('return_to', window.location.pathname + window.location.search);
    fetch(root + 'localization', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html,application/xhtml+xml', 'Content-Type': 'application/x-www-form-urlencoded' }
    })
      .then(function (r) { if (r.ok) window.location.reload(); })
      .catch(function () {});
  }

  // A manual pick in the theme's country/currency selector is the visitor's decision: remember it.
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.shopify-localization-form button[data-iso-code]');
    if (b) set(KEY, b.getAttribute('data-iso-code'));
  }, true);

  var saved = get(KEY);
  if (saved) {
    if (saved !== Shopify.country) switchTo(saved);
    return;
  }

  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(Shopify.country), { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var s = (d && d.suggestions && d.suggestions[0]) || null;
      var c = s && ((s.parts && s.parts.country) || s.country);
      var code = c && c.handle;
      if (!code || code === Shopify.country) { set(KEY, Shopify.country); return; }
      set(KEY, code);
      switchTo(code);
    })
    .catch(function () {});
})();
